export class PickListItem {
    alias: string;
    selected: boolean;

    constructor(_alias: string, _selected: boolean) {
        this.alias = _alias;
        this.selected = _selected;
    }
}
